import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { GeorefService } from '@services/georef/georef.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { Observable, startWith, debounceTime, map, of } from 'rxjs';

@Component({
  selector: 'app-buscar-provincia-georef',
  standalone: true,
  imports: [MatFormFieldModule, MatInputModule, MatAutocompleteModule, MatButtonModule, MatIconModule, MatTooltipModule, ReactiveFormsModule, NgxSpinnerModule, CommonModule],
  templateUrl: './buscar-provincia-georef.component.html',
  styleUrl: './buscar-provincia-georef.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BuscarProvinciaGeorefComponent {

  @Input() provinciaIngreso?: any;
  @Input() idLocalidad?: any;
  @Output() provinciaSeleccionada = new EventEmitter<any>();

  provinciaCtrl = new FormControl();
  provincias: any[] = [];
  filteredProvincias: Observable<any[]> = of([]);

  constructor(
    private georefService: GeorefService,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.cargarProvincias();

    if(this.idLocalidad)
      this.getProvinciaIdPorLocalidadId(this.idLocalidad)
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['provinciaIngreso'] && this.provinciaIngreso) {
      this.provinciaCtrl.setValue(this.provinciaIngreso, { emitEvent: false });
    }
    if(this.idLocalidad)
      this.getProvinciaIdPorLocalidadId(this.idLocalidad)
  }

  cargarProvincias(): void {
    this.spinner.show('spProvincia');
    this.georefService.getProvincias().subscribe({
      next: (resp) => {
        this.spinner.hide('spProvincia');
        this.provincias = resp.provincias;
        this.filteredProvincias = this.provinciaCtrl.valueChanges.pipe(
          startWith(''),
          debounceTime(300),
          map(value => typeof value === 'string' ? value : value?.nombre),
          map(nombre => this.filtrar(nombre))
        );

        // Si ya hay una provincia seleccionada previamente, asegurar que esté seteada
        if (this.provinciaIngreso) {
          const prov = this.provincias.find(p => p.id === this.provinciaIngreso);
          if (prov) {
            this.provinciaCtrl.setValue(prov, { emitEvent: false });
          }
        }
      },
      error: (error) => {
        this.spinner.hide('spProvincia');
        this.snackBar.showError(error, 'Error');
      }
    });
  }

  getProvinciaIdPorLocalidadId(idLocalidad:number): void {
    this.spinner.show('spProvinciaLocalidad');
    this.georefService.getProvinciaIdPorLocalidadId(idLocalidad).subscribe({
      next: (data) => {
        this.spinner.hide('spProvinciaLocalidad');
        if (data) {
          this.provinciaIngreso = data;
          this.cargarProvincias()
        }
      },
      error: (error) => {
        this.spinner.hide('spProvinciaLocalidad');
        this.snackBar.showError(error, 'Error');
      }
    });
  }

  filtrar(nombre: string): any[] {
    const val = nombre.toLowerCase();
    return this.provincias.filter(p => p.nombre.toLowerCase().includes(val));
  }

  displayFn(provincia: any): string {
    return provincia?.nombre ?? '';
  }

  onProvinciaSelected(provincia: any): void {
    this.provinciaSeleccionada.emit(provincia);
  }
}
